import React from 'react';
import PropTypes from 'prop-types';
import { QuickNavigation } from '../components';
import Cookies from 'universal-cookie';

const QuickNavigationContainer = props => {
  const cookies = new Cookies();
  const domainName = process.env.REACT_APP_DOMAIN;
  const logout = () => {
    // remove cookies
      cookies.remove("cpaas-token", { path: "/", domain: domainName });
      cookies.remove("whatsapp-token", { path: "/", domain: domainName });
      cookies.remove("sms-token", { path: "/", domain: domainName });
      cookies.remove("voice-token", { path: "/", domain: domainName });
      cookies.remove("rcs-token", { path: "/", domain: domainName });
      cookies.remove("email-token", { path: "/", domain: domainName });
      cookies.remove("userDetails", { path: "/", domain: domainName });
      cookies.remove("selected-tenant", { path: "/", domain: domainName });
      cookies.remove("productsList", { path: "/", domain: domainName });
      cookies.remove("sessionid", { path: "/", domain: domainName });
      cookies.remove("csrftoken", { path: "/", domain: domainName });
      localStorage.clear();

    window.location.href = '/';
  };

  const updatedProps = {
    ...props,
    logout
  };

  return <QuickNavigation {...updatedProps} />;
};

QuickNavigationContainer.propTypes = {
  history: PropTypes.object
};

export default QuickNavigationContainer;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/layout/containers/QuickNavigation.js